<div class="months">
  <mat-button-toggle class="month" *ngFor="let month of months" [value]="month" (change)="setMonthSelected($event)" [checked]="currentMonth.includes(month)">{{"months.long." + month.toLowerCase() | translate}}</mat-button-toggle>
</div>
<div class="btn-area">
  <button class="small-save-btn" (click)="validate()"><i class="fa-regular fa-save"></i></button>
</div>
